import { useTranslation } from 'react-i18next';
import { regExpName } from '@global/components/ActiveForm/regexp';
import * as yup from 'yup';
import { getLocaleConfig } from '@global/localization/services';
import { validatePostalCode } from './helper';

export const billingInformationSchema = () => {
  const { t } = useTranslation('', {
    keyPrefix: 'activeForm.validationErr',
  });

  return yup.object({
    CCname: yup
      .string()
      .max(60, t('max60CCNameLength'))
      .matches(regExpName, t('nameFormat'))
      .trim(t('nameFormat'))
      .required(t('nameReq')),
    phone: yup
      .string()
      .max(15, t('max15PhoneLength'))
      .min(1, t('phoneReq'))
      .required(t('phoneReq')),
    address1: yup
      .string()
      .max(30, t('max30AddressLength'))
      .min(4, t('addressLength'))
      .trim(t('addressLength'))
      .required(t('addressReq')),
    address2: yup
      .string()
      .max(30, t('max30AddressLength'))
      .notRequired()
      .min(4, t('addressLength'))
      .nullable()
      .transform((value) => (!!value ? value : null)),
    state: yup.string().when('country', (country) => {
      const stateSchema = yup.string();
      const { stateDropdown, stateDropdownLabel } = getLocaleConfig(country);
      const requireError = `${t('stateReq')} ${stateDropdownLabel}`;
      return stateDropdown ? stateSchema.required(requireError) : stateSchema;
    }),
    city: yup
      .string()
      .max(24, t('max24CityLength'))
      .trim(t('cityReq'))
      .required(t('cityReq')),
    zip: yup
      .string()
      .max(10, t('max10ZipLength'))
      .trim(t('zipReq'))
      .required(t('zipReq'))
      .test('postal-code-format', t('zipFormat'), function (value: string) {
        const { country } = this.parent;
        if (!value || !country) return true;

        const validation = validatePostalCode(value, country);

        if (!validation.isValid) {
          return this.createError({
            message: validation.error || t('zipFormat'),
          });
        }

        return true;
      }),
    country: yup.string().required(t('countryReq')),
  });
};
